import styled from 'styled-components';
import Colors from '../../constants/Colors';

const FavListPane = styled.div`
  display: grid;
  grid-gap: 2px;
  grid-template-rows: repeat(auto-fill, 50px);
  width: 320px;
  height: 100%;
  background: ${Colors.deepBlack};
`;

const FavRow = styled.div`
  background: ${Colors.darkSteel};
`;

export { FavListPane, FavRow };



// WEBPACK FOOTER //
// ./src/components/Favorites/FavListUI.tsx